const ELEVEN_API = process.env.VUE_APP_ELEVENLABS_API
const DEEPGRAM_API = process.env.VUE_APP_DEEPGRAM_API_KEY
const MURF_API = process.env.VUE_APP_MURF_API_KEY

export async function elevenLabsSTT(blob) {
  try {
    const formData = new FormData()
    formData.append('file', blob, 'recording.webm')
    formData.append('model_id', 'scribe_v1')

    const res = await fetch('https://api.elevenlabs.io/v1/speech-to-text', {
      method: 'POST',
      headers: { 'xi-api-key': ELEVEN_API },
      body: formData,
    })

    const json = await res.json()
    if (!res.ok) throw new Error(json?.error || 'ElevenLabs STT failed')

    return {
      text: json.text?.replace(/\n/g, ' ').trim() || '',
      language_code: json.language_code || null,
    }
  } catch (err) {
    console.error('❌ ElevenLabs STT error:', err.message)
    throw err
  }
}

export async function deepgramSTT(blob) {
  try {
    const response = await fetch('https://api.deepgram.com/v1/listen?punctuate=true&detect_language=true', {
      method: 'POST',
      headers: {
        Authorization: `Token ${DEEPGRAM_API}`,
        'Content-Type': blob.type || 'audio/webm',
      },
      body: blob,
    })

    const json = await response.json()

    if (!response.ok) {
      console.error('🛑 Deepgram Error:', json)
      throw new Error(json.error || 'Deepgram STT failed')
    }

    const transcript = json.results?.channels?.[0]?.alternatives?.[0]?.transcript?.trim() || ''
    const language_code = json.results?.channels?.[0]?.detected_language || null

    return {
      text: transcript,
      language_code, // 'en', 'de', etc.
      raw: json, // optional: keep full raw response if needed
    }
  } catch (err) {
    console.error('❌ Deepgram STT Error:', err.message)
    throw err
  }
}
